const styles = theme => ({
  container: {
    flexWrap: 'wrap',
    marginLeft: 0,
    paddingTop:0,
    paddingBottom:0,
    paddingLeft:0,
    paddingRight:0,
    marginTop:5,
    textDecoration: 'none',
    textColor: 'rgba(255, 255, 255, 1.0)',
    textDecoration: 'none',
    borderBottom: 'none',
    boxShadow: 'none',
    alignItems: 'left',
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  },
  rightIcon: {
   marginLeft: 3,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/Message/styles.js